<template>
  <div>
    <template-item label="生成的项">
      <el-checkbox-group :value="value">
        <el-checkbox
          v-for="item in options"
          :label="item.value"
          :key="item.value"
          @change="(value) => handleChange(item.value, value)"
          >{{ item.text }}
        </el-checkbox>
      </el-checkbox-group>
    </template-item>
    <cascade-province-section
      v-if="province"
      :data-source="provinceSource"
      :allowedValues="section.province.allowedValues"
      :forbiddenValues="section.province.forbiddenValues"
      @change-allowed-values="handleChangeAllowedValues"
      @change-forbidden-values="handleChangeForbiddenValues"
    />
    <cascade-city-section
      v-if="city"
      :provinces="allowedProvinces"
      :allowedValues="section.city.allowedValues"
      :forbiddenValues="section.city.forbiddenValues"
      @change-allowed-values="handleChangeAllowedCityValues"
      @change-forbidden-values="handleChangeForbiddenCityValues"
    />
    <cascade-county-section
      v-if="county"
      :provinces="allowedProvinces"
      :allowedValues="section.county.allowedValues"
      :forbiddenValues="section.county.forbiddenValues"
      @change-allowed-values="handleChangeAllowedCountyValues"
      @change-forbidden-values="handleChangeForbiddenCountyValues"
    />
  </div>
</template>
<script>
import {
  Cascader,
  Checkbox,
  CheckboxGroup,
  Divider,
  Radio,
  RadioGroup,
  Tooltip,
} from "element-ui";
import TemplateItem from "@/components/excel/designer/template/TemplateItem";
import CascadeProvinceSection from "@/components/excel/designer/template/area/cascade/section/ProvinceSection";
import CascadeCitySection from "@/components/excel/designer/template/area/cascade/section/CitySection";
import CascadeCountySection from "@/components/excel/designer/template/area/cascade/section/CountySection";
import { AreaSharedCache } from "@/utils/AreaSharedCache";

const options = [
  {
    value: 1,
    text: "省",
  },
  {
    value: 2,
    text: "市",
  },
  {
    value: 3,
    text: "县",
  },
];
export default {
  name: "cascader-area",
  components: {
    CascadeCountySection,
    CascadeCitySection,
    CascadeProvinceSection,
    TemplateItem,
    [Tooltip.name]: Tooltip,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Divider.name]: Divider,
    [Cascader.name]: Cascader,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  data() {
    return {
      constraintType: 1,
      value: [1, 2],
      options,
      provinceSource: [],
      section: {
        province: {
          allowedValues: null,
          forbiddenValues: null,
        },
        city: {
          allowedValues: null,
          forbiddenValues: null,
        },
        county: {
          allowedValues: null,
          forbiddenValues: null,
        },
      },
    };
  },
  computed: {
    province() {
      return this.value.includes(1);
    },
    city() {
      return this.value.includes(2);
    },
    county() {
      return this.value.includes(3);
    },
    allowedProvinces() {
      const { allowedValues, forbiddenValues } = this.section.province;
      const array = allowedValues
        ? this.provinceSource.filter((it) => allowedValues.includes(it.id))
        : this.provinceSource;
      if (Array.isArray(forbiddenValues) && forbiddenValues.length) {
        return array.filter((it) => !forbiddenValues.includes(it.id));
      }
      return array;
    },
  },
  methods: {
    handleChange(v, checked) {
      if (checked) {
        this.value.push(v);
      } else {
        this.value = this.value.filter((it) => it !== v);
      }
    },
    handleChangeAllowedValues(value) {
      this.section.province.allowedValues = value;
      // this.$nextTick(() => {
      //   this.value = [...this.value];
      // });
    },
    handleChangeForbiddenValues(value) {
      this.section.province.forbiddenValues = value;
      // this.$nextTick(() => {
      //   this.value = [...this.value];
      // });
    },
    handleChangeAllowedCityValues(value) {
      this.section.city.allowedValues = value;
    },
    handleChangeForbiddenCityValues(value) {
      this.section.city.forbiddenValues = value;
    },
    handleChangeAllowedCountyValues(value) {
      this.section.county.allowedValues = value;
    },
    handleChangeForbiddenCountyValues(value) {
      this.section.county.forbiddenValues = value;
    },
    filterProvinces(provinces) {
      const { allowedValues, forbiddenValues } = this.section.province;
      let array = provinces;
      if (allowedValues) {
        array = array.filter((it) => allowedValues.includes(it.id));
      }
      if (Array.isArray(forbiddenValues) && forbiddenValues.length) {
        array = array.filter((it) => !forbiddenValues.includes(it.id));
      }
      return array;
    },
  },
  mounted() {
    AreaSharedCache.loadChildren(0).then(
      (it) => (this.provinceSource = it || [])
    );
  },
};
</script>
